var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowSecond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 129,
    viewBox: "0 0 220 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 5,
    transform: "matrix(-0.937199 -0.348795 -0.348795 0.937199 130.01 92.0729)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 5,
    transform: "matrix(-0.937199 -0.348795 -0.348795 0.937199 164.425 94.2111)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 5,
    transform: "matrix(-0.937199 -0.348795 -0.348795 0.937199 22.4746 8.30432)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 5,
    transform: "matrix(-0.937199 -0.348795 -0.348795 0.937199 32.8262 29.229)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 5,
    transform: "matrix(-0.937199 -0.348795 -0.348795 0.937199 48.2127 50.9606)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 5,
    transform: "matrix(-0.937199 -0.348795 -0.348795 0.937199 71.9035 70.4475)",
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 5,
    transform: "matrix(-0.937199 -0.348795 -0.348795 0.937199 99.2127 85.9462)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205.373 84.1748C206.225 83.0533 205.682 81.4262 204.327 81.0413L188.949 76.6728C187.403 76.2336 185.997 77.7055 186.506 79.2301L192.215 96.3297C192.724 97.8544 194.733 98.186 195.705 96.906L205.373 84.1748Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSecond);
export default __webpack_public_path__ + "static/media/arrowSecond.0f9fb964e027f5f5c99c24e68cb3a3af.svg";
export { ForwardRef as ReactComponent };